export default () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_1_3116"
        //style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="5"
        y="7"
        width="14"
        height="9"
      >
        <path
          d="M6 14.5L12 8.5L18 14.5H6Z"
          fill="white"
          stroke="white"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_1_3116)">
        <path d="M0 0H24V24H0V0Z" fill="#2DCE89" />
      </g>
    </svg>
  );
};
